(function () {
  'use strict';
  var attempts = 0;
  var galleries = document.querySelectorAll('.product__slides');
  if (!galleries.length) return;
  var resizeTimer;
  var activeImage = null;
  var activeSource = '';

  function clearZoom() {
    if (window.jQuery) window.jQuery('.zoomContainerNulls').remove();
    activeImage = null;
    activeSource = '';
  }

  function attach(gallery) {
    var image = gallery.querySelector('.slick-current.slick-active .product__photo img, .product__photo.slick-current.slick-active img');
    if (!image || !image.complete || !image.naturalWidth || !image.getBoundingClientRect().width) return;
    var jq = window.jQuery;
    if (!jq || typeof jq.fn.elevateZoom !== 'function' || typeof window.exenAlternatif2 !== 'function') return;
    var source = image.currentSrc || image.src;
    if (activeImage === image && activeSource === source) return;
    activeImage = image;
    activeSource = source;
    window.exenAlternatif2(image);
    if (window.matchMedia('(max-width: 749px)').matches) {
      var zoom = jq(image).data('elevateZoom');
      if (zoom) {
        zoom.options.zoomType = 'inner';
        zoom.options.showLens = false;
      }
    }
  }

  function refresh(gallery) {
    window.requestAnimationFrame(function () { attach(gallery); });
  }

  function ready() {
    attempts += 1;
    var jq = window.jQuery;
    if (!jq || typeof jq.fn.elevateZoom !== 'function' || typeof window.exenAlternatif2 !== 'function') {
      if (attempts < 300) window.setTimeout(ready, 100);
      return;
    }
    galleries.forEach(function (gallery) {
      jq(gallery).on('beforeChange.nullsGalleryReady', clearZoom);
      jq(gallery).on('init.nullsGalleryReady afterChange.nullsGalleryReady setPosition.nullsGalleryReady', function () { refresh(gallery); });
      gallery.addEventListener('load', function (event) {
        if (event.target.tagName === 'IMG') refresh(gallery);
      }, true);
      refresh(gallery);
    });
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        clearZoom();
        galleries.forEach(refresh);
      }, 150);
    });
  }

  ready();
}());

